import { motion } from 'framer-motion';

const dataRights = [
    "Right to Access: Guests have the right to request access to the personal data we hold about them, including booking history and preferences.",
    "Right to Rectification: Guests can request corrections to any inaccurate or incomplete personal information associated with their profile or bookings.",
    "Right to Erasure (Right to be Forgotten): Guests may request the deletion of their personal data, provided it is no longer necessary for legal, financial, or ongoing booking purposes.",
    "Right to Restrict Processing: Guests have the right to request a temporary halt on processing their personal data under certain conditions.",
    "Right to Data Portability: Guests can ask for their personal data in a structured, commonly used, and machine-readable format to transfer to another service provider.",
    "Right to Object: Guests may object to the processing of their personal data for direct marketing and personalized room or package recommendations.",
    "Rights Related to Automated Decision-Making: Guests have the right not to be subject to decisions based solely on automated processing that significantly affects them.",
    "Right to Withdraw Consent: If data processing is based on consent, guests can withdraw it at any time without affecting the lawfulness of processing based on consent before withdrawal.",
    "Right to Lodge a Complaint: Guests have the right to lodge a complaint with a supervisory data protection authority if they feel their rights have been violated."
];

const DataRightsPage = () => {
    return (
        <>
            <div
                className="relative h-[656px] md:h-[464px] lg:h-[524px] w-full bg-cover bg-center flex flex-col justify-center items-center text-center "
                style={{
                    backgroundImage: `url('/images/TermsAndConditions/image1.webp')`, 
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                <div className="relative z-10 text-white px-6 sm:px-10 max-w-2xl">
                 
                    <h2 className="lora-display mb-4">
                        Data Rights & Privacy
                    </h2>
                    <p className="outfit text">
                        Effective date January 25, 2025
                    </p>
                </div>
            </div>
        
           <section className="flex flex-col justify-center items-center w-full lg:px-[106px] md:px-[64px] px-4 lg:my-[200px] md:my-[180px] my-[100px]">
                <div className="lg:w-[1025px] md:w-[706px] w-full mx-auto bg-white rounded-[24px] shadow-[0_4px_24px_rgba(0,0,0,0.06)] border border-gray-100 p-6 md:p-10 lg:p-16">
                    <div className="space-y-6 md:space-y-8">
                        {dataRights.map((right, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className="flex items-start gap-4 md:gap-6 pb-6 border-b border-gray-100 last:border-0 last:pb-0"
                            >
                                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#F1F3ED] text-[#668B42] flex items-center justify-center font-lora text-[14px] md:text-[18px] font-bold shadow-sm">
                                    {index + 1}
                                </div>
                                <p className="text-[#333333] outfit-text pt-1 md:pt-2 leading-relaxed">
                                    {right}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default DataRightsPage;
